// https://stackoverflow.com/questions/52447828/is-there-a-way-to-modify-the-page-title-with-react-router-v4
//
// Hook to change page title

import { useEffect } from 'react';

const useTitle = (title) => {
  useEffect(
    () => {
      const oldTitle = document.title;
      if (title) (document.title = title);
      // following line is optional, but will reset title when component unmounts
      return () => {
        document.title = oldTitle;
      };
    },
    [title],
  );
};

export default useTitle;
